import React, { FC } from 'react';

import EventsList from 'components/events/EventsList';
import EventsLayout from '../EventsLayout/EventsLayout';
import { EventsContextProvider } from 'components/context/EventsContext';

import { GET_HISTORY_EVENTS } from 'graphql/queries/events';

import { EventsType, Page } from 'types/enums';

import useStyles from './style';

const EventsHistory: FC = () => {
  const classes = useStyles();

  return (
    <EventsLayout>
      <EventsContextProvider
        value={{ query: GET_HISTORY_EVENTS, queryKey: EventsType.historyEvents }}
      >
        <EventsList
          className={classes.eventsHistoryTable}
          page={Page.eventsHistory}
          query={GET_HISTORY_EVENTS}
          queryKey={EventsType.historyEvents}
          columns={['historyStatus', 'djs', 'date', 'users', 'songs', 'planning']}
        />
      </EventsContextProvider>
    </EventsLayout>
  );
};

export default EventsHistory;
